import { SimpleGrid } from '@chakra-ui/react'
import { Box, Button, Flex, Panel, PanelProps, Text } from 'components'
import { useBreakpoint, usePermission } from 'utils'
import calendarIcon from '../../assets/calendar-icon.svg'
import momentsIcon from '../../assets/moment-icons/manage.svg'
import { useEventInfo } from '../../pages/EventInfoPage'
import { useEvent } from '../../utils/eventUtils'
import EmptyState, { Props as EmptyStateProps } from '../EmptyState'

export default function EventSetupState() {
  const breakpoint = useBreakpoint()
  const permission = usePermission()
  const { updateShowManage, updateMoments } = useEventInfo()
  const manageDescription = useMangeDescription()
  const ManageContainer = breakpoint > 2 ? DesktopContainer : MobileContainer
  const isEventViewer = permission.event === 'viewer'

  return (
    <ManageContainer>
      <Text textStyle="h6">Getting Setup</Text>
      <SimpleGrid columnGap={8} rowGap={4} columns={{ base: 1, lg: 2 }}>
        <SetupEmptyState
          iconSrc={calendarIcon}
          title="Event Setup"
          description={manageDescription}
          button={
            isEventViewer ? undefined : (
              <Button onClick={() => updateShowManage(true)}>Manage Event Settings</Button>
            )
          }
        />
        <SetupEmptyState
          iconSrc={momentsIcon}
          title="Moments Setup"
          description="Manage your activities and registration to be used by the devices at the event."
          button={
            isEventViewer ? undefined : (
              <Button onClick={() => updateMoments(true)}>Manage Moments</Button>
            )
          }
        />
      </SimpleGrid>
    </ManageContainer>
  )
}

function DesktopContainer(props: PanelProps) {
  return (
    <Panel
      direction="column"
      py={5}
      px={12}
      gap={5}
      background="rgba(255, 255, 255, 0.30)"
      {...props}
    />
  )
}

function MobileContainer(props: PanelProps) {
  return <Flex direction="column" gap={3} px={2} {...props} />
}

function useMangeDescription() {
  const { event } = useEvent()
  if (!event) return

  const { memberIds, hasImage, url } = event
  const manageAdds = [
    ...(!memberIds || memberIds.length < 2 ? ['members'] : []),
    ...(!url ? ['url'] : []),
    ...(!hasImage ? ['cover image'] : []),
  ]

  return manageAdds.length > 0
    ? `Add ${manageAdds.join(', ')} and review your registration settings.`
    : 'Update the members, cover image, url and review your registration settings.'
}

function SetupEmptyState(props: EmptyStateProps) {
  return (
    <Box
      backgroundColor="rgba(255, 255, 255, 0.4)"
      border="1px solid rgba(23, 23, 23, 0.10)"
      borderRadius="sm"
      p={8}
    >
      <EmptyState {...props} />
    </Box>
  )
}
